import React, {ChangeEvent} from "react";
import {debounce} from "lodash"
import {useAppDispatch, useAppSelector} from "../store";
import {accessibleCustomersSelector, changeSelectedCustomer, selectedCustomerSelector} from "../store/slice/auth";


function CustomerSelector() {

    const accessibleCustomers: CustomerAPICustomer[] = useAppSelector(accessibleCustomersSelector);
    const selectedCustomer: CustomerAPICustomer | null = useAppSelector(selectedCustomerSelector);
    const dispatch = useAppDispatch();

    const onChange = (e: ChangeEvent<any>) => {
        e.persist();
        debounce(() => {
            const selectedValue = parseInt(e.target.value);
            const selectedCustomer = accessibleCustomers.filter(customer => customer.id === selectedValue);
            if (selectedCustomer && selectedCustomer.length) {
                dispatch(changeSelectedCustomer(selectedCustomer[0]));
            }
        }, 200)();
    };

    if (!accessibleCustomers || accessibleCustomers.length <= 0) {
        return null;
    }

    const selectOptions = accessibleCustomers.map(customer => {
        return (
            <option key={customer.id} value={customer.id}>{customer.name}</option>
        );
    });

    const defaultValue = selectedCustomer && selectedCustomer.id;
    const isSingleCustomerUser = accessibleCustomers && accessibleCustomers.length <= 1;

    return (
        <div className="my-2 my-lg-0">
            <select className="form-select" onChange={onChange} defaultValue={defaultValue ?? undefined} disabled={isSingleCustomerUser}>
                {selectOptions}
            </select>
        </div>
    );
}

export default CustomerSelector;
